import React from "react";
import { getCurrentUser } from "../../v2/core/common_functions";
import store from "../../store";
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Example "componentStack":
        //   in ComponentThatThrows (created by App)
        //   in ErrorBoundary (created by App)
        //   in div (created by App)
        //   in App
        //logErrorToMyService(error, info.componentStack);
        console.error(error);
        console.error(info);
        this.logErrorToService(error);
    }
    
    async logErrorToService(error, componentStack) {
        const state = store.getState();
        const { base, doorConfigurationBuilder } = state;
        const currentUser = getCurrentUser(base);
        let confid = 0;
        if (doorConfigurationBuilder.configuration) confid = doorConfigurationBuilder.configuration.configurationId;
        try {
            console.log('Invio richiesta al server:', {
                messaggio: error.message,
                componentStack,
                currentUser,
                state,
            });
            const response = await fetch(`${process.env.REACT_APP_API_URL}/log-error`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messaggio: error.message,
                    currentUser: currentUser.id,
                    configurationId: confid
                })
            });
        } catch (err) {
            console.error('Errore durante l\'invio al server:', err);
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;